module.exports = __webpack_public_path__ + "img/balearic-islands.479e5517.png";